/**
 * API Configuration Module
 * 
 * Centralizes API endpoint configuration for the application.
 * Uses environment variables for configuration with sensible defaults.
 */

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api';

export const apiConfig = {
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
};

// Validate environment variables in development
if (import.meta.env.DEV && !import.meta.env.VITE_API_BASE_URL) {
  console.warn('⚠️ VITE_API_BASE_URL not configured, using default /api');
  console.warn('For local development, set VITE_API_BASE_URL in .env.local');
}

if (import.meta.env.PROD) {
  console.log('API configured for production:', API_BASE_URL);
}

export default apiConfig;
